import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Editing,
  Export,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  RequiredRule,
  StringLengthRule,
  PatternRule,
  RangeRule,
} from "devextreme-react/data-grid";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
} from "../../../helper/message";
import { useGetCodeWiseAppModuleFeaturePermission } from "../../../helper/sessionHelper";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import Modal from "react-modal";
import { Loader } from "../../Shared/PageLoader";
import TabPanel, { Item } from "devextreme-react/tab-panel";

const requestActionOptions = [
  { text: "Asset Movement", value: 1 },
  { text: "Asset Purchase", value: 2 },
  { text: "Asset Hire", value: 3 },
];

export default function UpdateActionOnRequestComponent(props) {
  debugger;
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    isCompleteLoading: false,
    isSavingAsDraft: false,
    isSending: false,
    requestId: location?.state?.requestId ?? 0,
    assetRequestSubList: [],
    isModalOpen: false,
    categoryId: 0,
    subCategoryId: 0,
    selectedTabIndex: 0,
    rowData: null,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [actionOnRequestData, setActionOnRequestData] = useState(null);
  const [assetRequestData, setAssetRequestData] = useState([]);
  const [assetAvailableLocationLst, setAssetAvailableLocationLst] = useState(
    []
  );
  const refDataGrid = useRef(null);
  const selectedAssets = [];

  const assetMovementfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission(
      "69186ae7-409c-4f66-82bb-fb1344441005"
    );
  const assetPurchasefeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission(
      "31c9e394-9cab-4e47-85d3-a3824e70d1e5"
    );
  const assetHirefeaturePermission = useGetCodeWiseAppModuleFeaturePermission(
    "aea33f40-5e4c-4af9-8992-213ab1f32608"
  );
  const assetActionOnRequestfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission(
      "61f04c61-3c68-415e-ba46-5fc1a05cc4f8"
    );

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Action On Request`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getApprovedAssetRequestLst();
      await getAssetRequestSubList();
      await getAssetRequestDetails(state.requestId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetRequestSubList = async () => {
    try {
      var assetRequestSubResponse = await assetService.addAssetRequestSubList(
        0,
        state?.requestId
      );
      setState((prevState) => ({
        ...prevState,
        assetRequestSubList: assetRequestSubResponse?.data ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getApprovedAssetRequestLst = async () => {
    try {
      let body = {
        requestId: state.requestId,
        statusId: Number(AssetSubStatus.AssetRequestApproved),
        userId: user?.userId,
      };
      const response = await assetService.getApprovedAssetRequest(body);
      var data = response?.data?.filter(
        (e) =>
          e.actionOnRequestStatusId !==
            Number(AssetSubStatus.ActionOnRequestApproved) &&
          e.actionOnRequestStatusId > 0
      );
      setActionOnRequestData(data[0] ?? null);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetRequestDetails = async (requestId) => {
    try {
      const response = await assetService.getassetDetailsById(
        requestId,
        user?.userId
      );
      setAssetRequestData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const checkMovementWorkFlow = async () => {
    try {
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetMovementfeaturePermission?.featureId,
        projectId: actionOnRequestData?.projectId,
        departmentId: actionOnRequestData?.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }
      let workflowData = await GetWorkFlowForApprovers(
        assetMovementfeaturePermission?.featureId,
        workflowCategoryId,
        actionOnRequestData?.projectId,
        actionOnRequestData?.departmentId
      );
      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset movement!!`);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const checkPurchaseWorkFlow = async (e) => {
    try {
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetPurchasefeaturePermission?.featureId,
        projectId: actionOnRequestData?.projectId,
        departmentId: actionOnRequestData?.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }
      let workflowData = await GetWorkFlowForApprovers(
        assetPurchasefeaturePermission?.featureId,
        workflowCategoryId,
        actionOnRequestData?.projectId,
        actionOnRequestData?.departmentId
      );
      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset purchase!!`);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const checkHireWorkFlow = async (e) => {
    try {
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetHirefeaturePermission?.featureId,
        projectId: actionOnRequestData?.projectId,
        departmentId: actionOnRequestData?.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }
      let workflowData = await GetWorkFlowForApprovers(
        assetHirefeaturePermission?.featureId,
        workflowCategoryId,
        actionOnRequestData?.projectId,
        actionOnRequestData?.departmentId
      );
      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset hire!!`);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const handleOnSaveAsDraftActionOnRequest = async (e) => {
    e.preventDefault();
    try {
      // const actiongrid = refDataGrid.current.instance;
      // actiongrid.saveEditData().then(() => {
      //   debugger;
      //   if (!actiongrid.hasEditData()) {
      //     console.log("Validation passed, proceed with submit");
      //     // call API or continue workflow
      //   } else {
      //     console.log("Validation failed");
      //   }
      // });
      //const isValid = actiongrid.validate(); // returns true/false

      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure you want to save changes on this action on request [${actionOnRequestData?.requestNo}]?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({
        ...prev,
        isSavingAsDraft: true,
      }));
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetActionOnRequestfeaturePermission?.featureId,
        projectId: actionOnRequestData.projectId,
        departmentId: actionOnRequestData.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetActionOnRequestfeaturePermission?.featureId,
        workflowCategoryId,
        actionOnRequestData.projectId,
        actionOnRequestData.departmentId
      );
      //const updatedRows = gridRef.current?.instance.getDataSource();
      const updatedData = state.assetRequestSubList; //updatedRows?._items;
      const allSelectedData = updatedData?.filter((e) => e.requestTypeId === 0);
      if (allSelectedData.length === updatedData.length) {
        await showErrorMessage(`Please set action for asset(s) !!`);
        setState((prev) => ({
          ...prev,
          isSavingAsDraft: false,
        }));
        return;
      }

      //const actionStatusId = allSelectedData.length === 0 ? AssetSubStatus.ActionOnRequestSentForApproval : AssetSubStatus.ActionPartiallyApproved;
      //console.log(updatedData._items);

      let selectedAssetRows = [];

      for (let i = 0; i < updatedData.length; i++) {
        const row = updatedData[i];
        if (row.requestTypeId > 0) {
          //#region [To check workflow as per request type]
          if (row.requestTypeId === 1) {
            if ((await checkMovementWorkFlow()) === false) {
              return;
            }
          } else if (row.requestTypeId === 2) {
            if ((await checkPurchaseWorkFlow()) === false) {
              return;
            }
          } else if (row.requestTypeId === 3) {
            if ((await checkHireWorkFlow()) === false) {
              return;
            }
          }
          //#endregion
          selectedAssetRows.push({
            assetRequestSubId: row.requestSubId,
            requestTypeId: row.requestTypeId,
            actionRemark: row.actionRemark,
          });
        }
      }

      let body = {
        assetRequestId: state?.requestId,
        workFlowId: workflowData.id,
        userId: user?.userId,
        assetActionStatusId: Number(AssetSubStatus.ActionOnRequestInDraftMode),
        UpdatedAssetRequestSubData: selectedAssetRows,
      };

      const response = await assetService.updateActionAssetRequestSub(body);
      setState((prev) => ({
        ...prev,
        isSavingAsDraft: false,
      }));
      isConfirmed = await showResponseMessage(response);
      if (response?.isSuccess) {
        if (user?.isIframe) {
          window.parent.postMessage(
            { type: "CLOSE_IFRAME" },
            process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
          );
          return;
        } else {
          if (location?.state?.sourceUrl === "ActionOnRequest") {
            navigate("/ApprovedAssetRequest");
          } else {
            navigate("/MyTasks");
          }
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({
        ...prev,
        isSavingAsDraft: false,
      }));
    }
  };

  const handleOnSendforApprovalActionOnRequest = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure you want to submit action on request [${actionOnRequestData?.requestNo}] for approval?</span>`;      
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({
        ...prev,
        isSending: true,
      }));
      let workflowCategoryId = 0;
      const updatedRows = refDataGrid?.current?.instance.getDataSource();
      const updatedData = updatedRows?._items;
      const allSelectedData = updatedData?.filter((e) => e.requestTypeId === 0);

      if (allSelectedData.length > 0) {
        await showErrorMessage(`Please set action for asset(s) !!`);
        setState((prev) => ({
          ...prev,
          isSending: false,
        }));
        return;
      }
      let categorybody = {
        formId: assetActionOnRequestfeaturePermission?.featureId,
        projectId: actionOnRequestData.projectId,
        departmentId: actionOnRequestData.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetActionOnRequestfeaturePermission?.featureId,
        workflowCategoryId,
        actionOnRequestData.projectId,
        actionOnRequestData.departmentId
      );

      const actionStatusId = Number(
        AssetSubStatus.ActionOnRequestSentForApproval
      );
      //console.log(updatedData._items);

      let workflowCategory = {};
      workflowCategory.formId =
        assetActionOnRequestfeaturePermission?.featureId;
      workflowCategory.categoryId = workflowCategoryId;
      workflowCategory.projectId = actionOnRequestData?.projectId;
      workflowCategory.departmentId = actionOnRequestData?.departmentId;

      let selectedAssetRows = [];
      updatedData?.forEach((row, index) => {
        if (row.requestTypeId > 0) {
          var selectedRow = {};
          selectedRow.assetRequestSubId = row.requestSubId;
          selectedRow.requestTypeId = row.requestTypeId;
          selectedAssetRows.push(selectedRow);
        }
      });

      let body = {
        assetRequestId: state?.requestId,
        remark: "",
        userId: user?.userId,
        assetActionStatusId: Number(AssetSubStatus.ActionOnRequestApproved),
        isSentForApproval: true,
      };

      const response = await assetService.updateActionAssetRequestSubStatus(
        body
      );
      setState((prev) => ({
        ...prev,
        isSending: false,
      }));
      isConfirmed = await showResponseMessage(response);
      if (response?.isSuccess) {
        if (user?.isIframe) {
          window.parent.postMessage(
            { type: "CLOSE_IFRAME" },
            process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
          );
          return;
        } else {
          if (location?.state?.sourceUrl === "ActionOnRequest") {
            navigate("/ApprovedAssetRequest");
          } else {
            navigate("/MyTasks");
          }
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({
        ...prev,
        isSending: false,
      }));
    }
  };

  const getAssetAvailableLocations = async (categoryId, subCategoryId) => {
    try {
      const response = await assetService.getAssetAvailableLocations(
        categoryId,
        subCategoryId
      );
      setAssetAvailableLocationLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenModal = (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isModalOpen: true,
        categoryId: data?.categoryId ?? 0,
        subCategoryId: data?.subCategoryId ?? 0,
        rowData: data ?? null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isModalOpen: false,
        categoryId: 0,
        subCategoryId: 0,
        selectedTabIndex: 0,
        rowData: null,
      }));
      setAssetAvailableLocationLst([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div
          className="card"
          style={{ borderRadius: "6px", marginTop: "-10px" }}
        >
          <div
            className="card-header p-2"
            style={{
              backgroundColor: "#e3e7ff",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                Request No&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {actionOnRequestData?.requestNo}
                </strong>
                &nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {moment(actionOnRequestData?.requestedDate)
                    ?.format(
                      DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                    )
                    ?.toString()}
                </strong>
              </h6>
            </div>

            <div className="float-right">
              {!user?.isIframe && (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      if (location?.state?.sourceUrl === "ActionOnRequest") {
                        navigate("/ApprovedAssetRequest");
                      } else {
                        navigate("/MyTasks");
                      }
                    }}
                  >
                    <span title="Back ">
                      <i className="fas fa-arrow-left" />
                      &nbsp;&nbsp;Back
                    </span>
                  </button>
                </>
              )}
              {!actionOnRequestData?.stageApproved && (
                <>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    title="Cancel"
                    onClick={async (e) => {
                      await handleOnSaveAsDraftActionOnRequest(e);
                    }}
                    disabled={state.isSending}
                  >
                    <i
                      className={`fas fa-${
                        state.isSavingAsDraft
                          ? `spinner fa-spin`
                          : `file-signature`
                      }`}
                    ></i>
                    &nbsp;&nbsp;Save as Draft
                  </button>
                  &nbsp;&nbsp;
                </>
              )}
              {!actionOnRequestData?.stageApproved &&
                (actionOnRequestData?.actionOnRequestStatusId ===
                  AssetSubStatus.ActionOnRequestInDraftMode ||
                  actionOnRequestData?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestBackToDraft ||
                  actionOnRequestData?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestRecall) && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      title="Cancel"
                      onClick={async (e) => {
                        await handleOnSendforApprovalActionOnRequest(e);
                      }}
                      disabled={state.isSavingAsDraft}
                    >
                      <i
                        className={`fas fa-${
                          state.isSending ? `spinner fa-spin` : `check`
                        }`}
                      ></i>
                      &nbsp;&nbsp;Send for Approval
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-9">
            <div className="card">
              <div className="card-body">
                {/* <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          ACTION ON REQUEST
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {actionOnRequestData?.requestNo ?? ""}
                        </h6>
                      </td>
                    </tr>
                  </table>
                </div> */}
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    {/* <tr>
                      <td style={{ fontSize: "0.9rem" }}>Request No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.requestNo ?? ""}
                      </td>
                    </tr> */}
                    <tr>
                      <td width="150px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.fromName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.toName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Site</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.projectName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Note</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.remark ?? ""}
                      </td>
                    </tr>
                    {/* <tr>
                      <td style={{ fontSize: "0.9rem" }}>Date</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {actionOnRequestData?.requestedDate
                          ? moment(actionOnRequestData?.requestedDate)
                              ?.format(
                                DefaultDateFormat.MomentDisplayDateTimeFullFormat
                              )
                              ?.toString()
                          : ""}
                      </td>
                    </tr> */}
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div className="message-body">
                  <DataGrid
                    ref={refDataGrid}
                    dataSource={state.assetRequestSubList}
                    showColumnLines={false}
                    showRowLines={false}
                    showBorders={false}
                    columnAutoWidth={true}
                    allowColumnResizing={false}
                    allowColumnReordering={true}
                    //onSelectionChanged={onSelectionChanged}
                    onSelectionChanged={(e) => {
                      setSelectedRowKeys(e.selectedRowKeys);
                      setSelectedRowData(e.selectedRowsData);
                    }}
                    selectedRowKeys={selectedRowKeys}
                    keyExpr="requestSubId"
                    // onRowPrepared={(e) => {
                    //   if (e.rowType === "data") {
                    //     if (e.data?.isSent === true)
                    //       {
                    //       // e.rowElement.cells[0].hidden = true;
                    //       e.rowElement.cells[0].style.visibility = "hidden";
                    //     }
                    //   }
                    // }}
                    onCellValueChanged={(e) => {
                      if (e.column.dataField === "requestTypeId") {
                        const newValue = e.value;
                        // Filter rows matching the new dropdown value
                        const matchingKeys = state.assetRequestSubList
                          .filter((item) => item.requestTypeId === newValue)
                          .map((item) => item.requestSubId);

                        setSelectedRowKeys(matchingKeys);
                        selectedAssets.push(matchingKeys);
                      }
                    }}
                    onCellPrepared={(e) => {
                      if (
                        e.rowType === "data" &&
                        e.column.dataField === "requestTypeId"
                      ) {
                        // Example: highlight based on value
                        if (e.data.requestTypeId === 1) {
                          e.cellElement.style.backgroundColor = "#d1ffd1"; // light green
                        } else if (e.data.requestTypeId === 2) {
                          e.cellElement.style.backgroundColor = "#ffe0e0"; // light red
                        } else if (e.data.requestTypeId === 3) {
                          e.cellElement.style.backgroundColor = "#cacbfaff"; // light red
                        } else {
                          e.cellElement.style.backgroundColor = "#FFFF8F"; // neutral gray
                        }
                      }
                    }}

                    //#region
                    // onEditorPreparing={(e) => {
                    //   if (e.dataField === "requestTypeId" && e.parentType === "dataRow") {
                    //     e.editorOptions.onValueChanged = (args) => {
                    //       const selectedValue = args.value;
                    //       console.log("Selected value in grid dropdown:", selectedValue);

                    //       debugger;
                    //       // Optional: update selection or trigger logic
                    //       const matchingKeys = state.subAssetsList
                    //         .filter((item) => item.requestTypeId === selectedValue)
                    //         .map((item) => item.requestSubId);

                    //       setSelectedRowKeys(selectedValue);
                    //       selectedAssets.push(selectedValue);
                    //     };
                    //   }
                    // }}

                    // onEditorPreparing={(e) => {
                    //   if (e.dataField === "requestTypeId" && e.parentType === "dataRow") {
                    //     e.editorOptions.onValueChanged = (args) => {
                    //       debugger;
                    //       //setSelectedRowKeys.push(args.value);
                    //       selectedAssets.push(args.value);
                    //       //console.log("Dropdown changed to:", args.value);
                    //     };
                    //   }
                    // }}

                    //onRowPrepared={}
                    //defaultSelectionFilter={selectionFilterKeys}
                    //#endregion
                  >
                    <Editing mode="cell" allowUpdating={true} />
                    {/* <Selection
                                  key="isSent"
                                  mode="multiple"
                                  selectAllMode={"allPages"}
                                  showCheckBoxesMode={"always"}
                                  //deferred={true}
                                /> */}
                    {/* <FilterRow visible={true} /> */}
                    <Column
                      dataField=""
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={30}
                      cellRender={(data) => {
                        const idPrefix = `icon-${data?.data?.requestSubId}`;
                        return (
                          <>
                            <div style={{ display: "flex" }}>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-view`}
                                  className="iconify-size mr-1"
                                  title="View Asset Available/Allocated List"
                                  tooltip="View Asset Available/Allocated List"
                                  icon="solar:document-text-outline"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => {
                                    handleOnOpenModal(e, data?.data);
                                  }}
                                />
                              </span>
                            </div>
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="categoryName"
                      caption="Asset Description"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      allowEditing={false}
                    />
                    <Column
                      dataField="requiredQty"
                      caption="Req. Qty"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      allowEditing={false}
                    />
                    <Column
                      dataField="requirementDate"
                      caption="Date of Requirement"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      dataType="date"
                      format="dd-MMM-yyyy"
                      allowEditing={false}
                    />
                    <Column
                      dataField="requestTypeId"
                      caption="Action"
                      width={200}
                    >
                      <Lookup
                        dataSource={requestActionOptions}
                        valueExpr="value"
                        displayExpr="text"
                      />
                      <RequiredRule message="Action is required" />
                      <RangeRule
                        min={1}
                        max={3}
                        message="Invalid action selected"
                      />
                    </Column>
                    <Column
                      dataField="actionRemark"
                      caption="Remark"
                      allowEditing={true}
                      width={170}
                    >
                      {/* Required field */}
                      <RequiredRule message="Remark is required" />
                      {/* Minimum length */}
                      {/* <StringLengthRule
                        min={5}
                        message="Remark must be at least 5 characters"
                      /> */}
                      {/* Maximum length */}
                      <StringLengthRule
                        max={200}
                        message="Remark cannot exceed 200 characters"
                      />
                    </Column>
                    <Column
                      dataField="purpose"
                      caption="Purpose"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      allowEditing={false}
                    />
                    <Column
                      dataField="requestNo"
                      caption="Asset No"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      allowEditing={false}
                    />
                    <Column
                      dataField="assetStatus"
                      caption="Action Status"
                      allowSearch={true}
                      allowFiltering={false}
                      allowSorting={true}
                      allowEditing={false}
                    />
                    <HeaderFilter visible={false} />
                    <SearchPanel
                      visible={false}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                    <Paging defaultPageSize={15} />
                    <Pager
                      displayMode="compact"
                      showInfo={true}
                      visible={false}
                    />
                    <Export enabled={false} fileName="SubAssetList" />
                  </DataGrid>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div className="list-group">
                  {assetRequestData?.history?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item.statusName === "Recall"
                          ? "Recall Requested"
                          : item.statusName}{" "}
                        by {item.fullName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>{item.remarkDate ?? ""}</small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.remarks}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetRequestData?.assetRequestAttachments?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetRequestData?.assetRequestAttachments?.map(
                    (item, index) => (
                      <div className="list-group">
                        <div
                          key={index}
                          className="list-group-item list-group-item-action flex-column align-items-start"
                          style={{
                            borderBottom: "1px solid #cfcfcf",
                            marginBottom: "0.5rem",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <div className="d-flex w-100 justify-content-between align-items-center">
                            <small
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                window.open(item?.fileUrl, "_blank");
                              }}
                            >
                              {item?.assetFileName}
                              {/* item?.fileType */}
                            </small>
                            <small>{item?.fileSize} kb</small>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={state.isModalOpen}
        onAfterOpen={async () => {
          await getAssetAvailableLocations(
            state.categoryId,
            state.subCategoryId
          );
        }}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Asset Available/Allocated Locations List"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            Asset Available/Allocated Locations For&nbsp;
            {state.rowData?.categoryName}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <TabPanel
            loop={true}
            width={"100%"}
            height={"80%"}
            animationEnabled={true}
            swipeEnabled={false}
            tabsPosition={"top"}
            stylingMode={"secondary"}
            iconPosition={"top"}
            selectedIndex={state.selectedTabIndex}
            onSelectedIndexChange={(index) => {
              try {
                setState((prev) => ({ ...prev, selectedTabIndex: index }));
              } catch (error) {
                console.log(error);
              }
            }}
          >
            <Item
              title={`Asset At ${actionOnRequestData?.projectName} (${
                assetAvailableLocationLst?.filter(
                  (f) =>
                    f.assetStatusId === Number(AssetSubStatus.Allocated) &&
                    f.projectId === actionOnRequestData?.projectId
                )?.length
              })`}
              icon="home"
            >
              <div className="row content-header">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="row">
                    <div className="col-12 col-lg-12">
                      <div className="form-group mb-2">
                        <DataGrid
                          dataSource={assetAvailableLocationLst?.filter(
                            (f) =>
                              f.assetStatusId ===
                                Number(AssetSubStatus.Allocated) &&
                              f.projectId === actionOnRequestData?.projectId
                          )}
                          showBorders={true}
                          columnAutoWidth={true}
                          allowColumnResizing={true}
                          showRowLines={true}
                          showColumnLines={false}
                          height={250}
                        >
                          <Column
                            dataField="ownershipType"
                            caption="Owner Type"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vendorName"
                            caption="Vendor"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetName"
                            caption="Asset"
                            allowSearch={true}
                            allowSorting={true}
                            calculateCellValue={(data) => {
                              return `${data?.data?.assetName || ""} ${
                                data?.data?.assetSerialNo || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              return (
                                <>
                                  <span>{data?.data?.assetName ?? ""}</span>
                                  {data?.data?.assetSerialNo && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          color: "#b1b1b1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {data?.data?.assetSerialNo ?? ""}
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          />
                          <Column
                            dataField="sapFleetId"
                            caption="SAP Fleet Id"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vehicleNo"
                            caption="Registration No"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetIssuedDate"
                            caption="Issued Date"
                            allowSearch={true}
                            allowFiltering={false}
                            calculateCellValue={(data) => {
                              return `${data?.assetIssuedDate || ""} ${
                                data?.updatedUserName || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              if (data?.data?.assetIssuedDate) {
                                return (
                                  <>
                                    <span>
                                      {moment(
                                        data?.data?.assetIssuedDate
                                      )?.format(
                                        DefaultDateFormat.MomentDisplayDateTime24Format
                                      )}
                                    </span>
                                    <br />
                                    <div
                                      style={{
                                        color: "#b1b1b1",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {data?.data?.updatedUserName ?? ""}
                                    </div>
                                  </>
                                );
                              } else {
                                return "";
                              }
                            }}
                          />
                          {/* <Column
                            dataField="currentDate"
                            caption="Current Date"
                            allowSearch={true}
                            allowFiltering={false}
                            allowSorting={true}
                            dataType="datetime"
                            format={DefaultDateFormat.GridDateTime24Format}
                          />
                          <Column
                            dataField="duration"
                            caption="Req. Months"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />
                          <Column
                            dataField="requestedDays"
                            caption="Req. Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />

                          <Column
                            dataField="noOfDays"
                            caption="Utilisation Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />
                          <Column
                            dataField="remainingDays"
                            caption="Remaining Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                            visible={false}
                          />
                          <Column
                            dataField="issueRemark"
                            caption="Status"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetCreatedDate"
                            caption="Created Date"
                            allowSearch={true}
                            allowFiltering={false}
                            visible={false}
                            calculateCellValue={(data) => {
                              return `${data?.assetCreatedDate || ""} ${
                                data?.createdUserName || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              if (data?.data?.assetCreatedDate) {
                                return (
                                  <>
                                    <span>
                                      {moment(
                                        data?.data?.assetCreatedDate
                                      ).format("DD/MM/YYYY") +
                                        " " +
                                        moment(
                                          data?.data?.assetCreatedDate
                                        ).format("LT") ?? ""}
                                    </span>
                                    <br />
                                    <div
                                      style={{
                                        color: "#b1b1b1",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {data?.data?.createdUserName ?? ""}
                                    </div>
                                  </>
                                );
                              } else {
                                return "";
                              }
                            }}
                          /> */}
                          <HeaderFilter visible={false} />
                          <Scrolling mode="virtual" />
                          <SearchPanel
                            visible={true}
                            highlightCaseSensitive={true}
                            width={240}
                            placeholder="Search..."
                          />
                        </DataGrid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Item>
            <Item
              title={`Asset At All Sites (${
                assetAvailableLocationLst?.filter(
                  (f) => f.assetStatusId === Number(AssetSubStatus.Allocated)
                )?.length
              })`}
              icon="product"
            >
              <div className="row content-header">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="row">
                    <div className="col-12 col-lg-12">
                      <div className="form-group mb-2">
                        <DataGrid
                          dataSource={assetAvailableLocationLst?.filter(
                            (f) =>
                              f.assetStatusId ===
                              Number(AssetSubStatus.Allocated)
                          )}
                          showBorders={true}
                          columnAutoWidth={true}
                          allowColumnResizing={true}
                          showRowLines={true}
                          showColumnLines={false}
                          height={250}
                        >
                          <Column
                            dataField="ownershipType"
                            caption="Owner Type"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vendorName"
                            caption="Vendor"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetName"
                            caption="Asset"
                            allowSearch={true}
                            allowSorting={true}
                            calculateCellValue={(data) => {
                              return `${data?.data?.assetName || ""} ${
                                data?.data?.assetSerialNo || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              return (
                                <>
                                  <span>{data?.data?.assetName ?? ""}</span>
                                  {data?.data?.assetSerialNo && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          color: "#b1b1b1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {data?.data?.assetSerialNo ?? ""}
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          />
                          <Column
                            dataField="sapFleetId"
                            caption="SAP Fleet Id"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vehicleNo"
                            caption="Registration No"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetIssuedDate"
                            caption="Issued Date"
                            allowSearch={true}
                            allowFiltering={false}
                            calculateCellValue={(data) => {
                              return `${data?.assetIssuedDate || ""} ${
                                data?.updatedUserName || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              if (data?.data?.assetIssuedDate) {
                                return (
                                  <>
                                    <span>
                                      {moment(
                                        data?.data?.assetIssuedDate
                                      )?.format(
                                        DefaultDateFormat.MomentDisplayDateTime24Format
                                      )}
                                    </span>
                                    <br />
                                    <div
                                      style={{
                                        color: "#b1b1b1",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {data?.data?.updatedUserName ?? ""}
                                    </div>
                                  </>
                                );
                              } else {
                                return "";
                              }
                            }}
                          />
                          <Column
                            dataField="projectName"
                            caption="Project Location"
                            allowSearch={true}
                            allowSorting={true}
                            width={150}
                            calculateCellValue={(data) => {
                              return `${data?.data?.projectName || ""} ${
                                data?.data?.assetLocation || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              return (
                                <>
                                  <span>{data?.data?.projectName ?? ""}</span>
                                  {data?.data?.assetLocation && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          color: "#b1b1b1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {data?.data?.assetLocation ?? ""}
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          />
                          {/* 
                          <Column
                            dataField="currentDate"
                            caption="Current Date"
                            allowSearch={true}
                            allowFiltering={false}
                            allowSorting={true}
                            dataType="datetime"
                            format={DefaultDateFormat.GridDateTime24Format}
                          />
                          <Column
                            dataField="duration"
                            caption="Req. Months"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />
                          <Column
                            dataField="requestedDays"
                            caption="Req. Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />

                          <Column
                            dataField="noOfDays"
                            caption="Utilisation Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                          />
                          <Column
                            dataField="remainingDays"
                            caption="Remaining Days"
                            allowSearch={true}
                            allowSorting={true}
                            alignment={"center"}
                            visible={false}
                          />
                          <Column
                            dataField="issueRemark"
                            caption="Status"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetCreatedDate"
                            caption="Created Date"
                            allowSearch={true}
                            allowFiltering={false}
                            visible={false}
                            calculateCellValue={(data) => {
                              return `${data?.assetCreatedDate || ""} ${
                                data?.createdUserName || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              if (data?.data?.assetCreatedDate) {
                                return (
                                  <>
                                    <span>
                                      {moment(
                                        data?.data?.assetCreatedDate
                                      ).format("DD/MM/YYYY") +
                                        " " +
                                        moment(
                                          data?.data?.assetCreatedDate
                                        ).format("LT") ?? ""}
                                    </span>
                                    <br />
                                    <div
                                      style={{
                                        color: "#b1b1b1",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {data?.data?.createdUserName ?? ""}
                                    </div>
                                  </>
                                );
                              } else {
                                return "";
                              }
                            }}
                          /> */}
                          <HeaderFilter visible={false} />
                          <Scrolling mode="virtual" />
                          <SearchPanel
                            visible={true}
                            highlightCaseSensitive={true}
                            width={240}
                            placeholder="Search..."
                          />
                        </DataGrid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Item>
            <Item
              title={`Asset At ${actionOnRequestData?.companyCode} (${
                assetAvailableLocationLst?.filter(
                  (f) => f.assetStatusId === Number(AssetSubStatus.Available)
                )?.length
              })`}
              icon="box"
            >
              <div className="row content-header">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="row">
                    <div className="col-12 col-lg-12">
                      <div className="form-group mb-2">
                        <DataGrid
                          dataSource={assetAvailableLocationLst?.filter(
                            (f) =>
                              f.assetStatusId ===
                              Number(AssetSubStatus.Available)
                          )}
                          showBorders={true}
                          columnAutoWidth={true}
                          allowColumnResizing={true}
                          showRowLines={true}
                          showColumnLines={false}
                          height={250}
                        >
                          <Column
                            dataField="ownershipType"
                            caption="Owner Type"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vendorName"
                            caption="Vendor"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="assetName"
                            caption="Asset"
                            allowSearch={true}
                            allowSorting={true}
                            calculateCellValue={(data) => {
                              return `${data?.data?.assetName || ""} ${
                                data?.data?.assetSerialNo || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              return (
                                <>
                                  <span>{data?.data?.assetName ?? ""}</span>
                                  {data?.data?.assetSerialNo && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          color: "#b1b1b1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {data?.data?.assetSerialNo ?? ""}
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          />
                          <Column
                            dataField="sapFleetId"
                            caption="SAP Fleet Id"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="vehicleNo"
                            caption="Registration No"
                            allowSearch={true}
                            allowSorting={true}
                          />
                          <Column
                            dataField="projectName"
                            caption="Project Location"
                            allowSearch={true}
                            allowSorting={true}
                            calculateCellValue={(data) => {
                              return `${data?.data?.projectName || ""} ${
                                data?.data?.assetLocation || ""
                              }`;
                            }}
                            cellRender={(data) => {
                              return (
                                <>
                                  <span>{data?.data?.projectName ?? ""}</span>
                                  {data?.data?.assetLocation && (
                                    <>
                                      <br />
                                      <div
                                        style={{
                                          color: "#b1b1b1",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {data?.data?.assetLocation ?? ""}
                                      </div>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          />
                          <HeaderFilter visible={false} />
                          <Scrolling mode="virtual" />
                          <SearchPanel
                            visible={true}
                            highlightCaseSensitive={true}
                            width={240}
                            placeholder="Search..."
                          />
                        </DataGrid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Item>
          </TabPanel>
        </div>
      </Modal>
      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
